import { BaseAPI } from './BaseAPI.js'
import {
  VoicemailMessage,
  VoicemailMessageEvents,
} from '../types/VoicemailMessage.js'

export default class VoicemailMessagesAPI extends BaseAPI<
  VoicemailMessage,
  VoicemailMessageEvents
> {
  override get hasEvents(): boolean {
    return true
  }
  override get resource(): string {
    return '/voicemailMessages'
  }

  public async getRecording(id: number) {
    const { data } = await this._client.get(`voicemailMessages/${id}.ogg`, {
      headers: {
        'Content-Type': 'audio/ogg',
      },
      responseType: 'arraybuffer',
    })
    return new Blob([data], {
      type: 'audio/ogg',
    })
  }
}
